export default class Footer {

  constructor(el) {
    this.el = el
    this.form = el.querySelector('form.newsletter--form')
    if (!this.form) return

    this.mailer = this.form.dataset.mailer

    this.bindSubmit()
  }

  bindSubmit() {
    this.form.addEventListener('submit', (e) => {
      e.preventDefault()

      const amispam = this.form.querySelector('#amispam')
      if (amispam && amispam.value) {
        console.error('Oh no ! I m Spam')
        return
      }

      const formData = new FormData(this.form)

      this.setState('loading')

      fetch(this.mailer, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
        .then(response => {
          if (!response.ok) {
            return response.text().then(text => {
              throw new Error(`HTTP ${response.status} — ${this.mailer}\n${text}`)
            })
          }
          return response
        })
        .catch(error => console.error('[newsletter]', error))
        .finally(() => {
          this.setState('sent')
          setTimeout(() => {
            this.setState('submit')
            this.form.reset()
          }, 5000)
        })
    })

    this.form.querySelectorAll('.newsletter--submit.is-loading, .newsletter--submit.is-sent').forEach(btn => {
      btn.addEventListener('click', e => e.preventDefault())
    })
  }

  setState(state) {
    this.form.querySelectorAll('.newsletter--submit').forEach(btn => btn.classList.remove('is-active'))
    const target = this.form.querySelector(`.newsletter--submit.is-${state}`)
    if (target) target.classList.add('is-active')
  }

}
